import { Separator } from '@/components/ui/separator'
import { toNote } from '@/lib/link'
import { cn } from '@/lib/utils'
import { useSecondaryPage } from '@/PageManager'
import { Event } from '@nostr/tools/wasm'
import Collapsible from '../Collapsible'
import GroupedNotesIndicator from '../GroupedNoteList/Indicator'
import Note from '../Note'
import NoteStats from '../NoteStats'
import PendingUndoButton from '../PendingUndoButton'
import PinnedButton from './PinnedButton'
import RepostDescription from './RepostDescription'

export default function MainNoteCard({
  event,
  className,
  reposters,
  repostEvent,
  embedded,
  simple,
  originalNoteId,
  groupedNotesTotalCount,
  onAllNotesRead,
  areAllNotesRead,
  pinned = false,
  displayScore,
  clamp = false
}: {
  event: Event
  className?: string
  reposters?: string[]
  repostEvent?: Event
  embedded?: boolean
  simple?: boolean
  originalNoteId?: string
  groupedNotesTotalCount?: number
  onAllNotesRead?: () => void
  areAllNotesRead?: boolean
  pinned?: boolean
  displayScore?: number
  clamp?: boolean
}) {
  const { push } = useSecondaryPage()

  return (
    <div
      className={cn(className, 'overflow-visible')}
      onClick={(e) => {
        e.stopPropagation()
        push(toNote(originalNoteId ?? event))
      }}
    >
      <div
        className={cn(
          'cursor-pointer transition-colors hover:bg-muted active:bg-muted overflow-visible group/hoverablenote',
          embedded ? 'font-sans text-base p-2 sm:p-3 border rounded-lg' : 'pt-3 pb-1'
        )}
      >
        <Collapsible alwaysExpand={embedded}>
          {pinned && <PinnedButton event={event} />}
          <RepostDescription
            className={embedded ? '' : 'px-4'}
            reposters={reposters}
            event={repostEvent}
          />
          <Note
            className={embedded ? '' : 'px-4'}
            size={embedded ? 'small' : 'normal'}
            event={event}
            simple={simple}
            originalNoteId={originalNoteId}
            displayScore={displayScore}
            clamp={clamp}
          />
        </Collapsible>
        {!embedded && <NoteStats className="mt-3 px-4" event={event} />}
        {!embedded && repostEvent && <PendingUndoButton event={repostEvent} className="mt-1" />}
        {!embedded && groupedNotesTotalCount && (
          <GroupedNotesIndicator
            event={event}
            totalNotesInTimeframe={groupedNotesTotalCount}
            onAllNotesRead={onAllNotesRead}
            areAllNotesRead={areAllNotesRead}
          />
        )}
      </div>
      {!embedded && <Separator />}
    </div>
  )
}
